var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalaxyBrainReactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 108.28 108.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #4caf50;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.24px;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.59,71.85c8.37.88,6.59-3.14,12.79-.61,4.38,1.8,7.32,2.93,9.96,3.3l-.02.14s-.27,6.11-4.55,9.15c-1.72,1.22-4.1,1.95-7.38,1.57-11.4-1.3-12.13-13.63-12.13-13.63l.03-.13c.41.09.84.16,1.31.21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M19.43,47.52c-.33-1.83.11-3.97,1.76-6.17,1.34-1.78,2.94-2.78,2.94-2.78,1.99-13.62,15.3-12.63,15.3-12.63,7.65-8.34,16.68-3.06,16.68-3.06,12.32-4.72,18.05,4.2,18.05,4.2,10.01-3.86,12.16,6.89,12.16,6.89,10.49,1.14,8.11,12.78,8.11,12.78,4.54,4.61.38,9.26.38,9.26-.84,14.45-17,11.4-17,11.4-.48,4.91-6.76,10.89-16.32,7.28-10.56-3.99-12.8,8.64-13.8,10.25-1.35,2.16-2.27,3.67-2.73,4.44-.23.39-.63.64-1.08.67-.61.04-1.57.09-2.72.09-2.03,0-5.12.36-2.73-1.82,2.41-2.17,3.31-4.51,3.31-4.51,4.28-3.04,4.55-9.15,4.55-9.15l.02-.14c-2.64-.37-5.58-1.5-9.96-3.3-6.2-2.53-4.41,1.49-12.79.61-.47-.05-.9-.12-1.31-.21-7.9-1.74-5.49-10.8-5.49-10.8-2.43-5.49.19-13.08,2.64-13.32Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.77,83.83s-.9,2.35-3.31,4.51c-2.4,2.18.7,1.82,2.73,1.82,1.14,0,2.11-.05,2.72-.09.45-.03.85-.28,1.08-.67.46-.77,1.37-2.29,2.73-4.44,1-1.6,3.24-14.24,13.8-10.25,9.56,3.61,15.83-2.37,16.32-7.28.1-1.02-.05-2.01-.47-2.84"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M19.43,47.52c-2.45.24-5.06,7.83-2.64,13.32.77,1.73,2.05,3.26,3.98,4.27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M16.8,60.84s-2.42,9.06,5.49,10.8c.41.09.84.16,1.31.21,8.37.88,6.59-3.14,12.79-.61,4.38,1.8,7.32,2.93,9.96,3.3,1.09.16,2.13.18,3.2.07"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M22.25,71.77s.73,12.32,12.13,13.63c3.28.37,5.66-.35,7.38-1.57,4.28-3.04,4.55-9.15,4.55-9.15"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.5,47.89c-.25.43-.39.94-.41,1.47-.11,2.13,1.65,4.51,6.55,3.34,6.82-1.63,6.82-10.98.48-14.32-6.35-3.35-23.12-3.76-30.7,8.65-7.58,12.42,1.57,22.85,8.38,18.96,0,0,5.8,5.48,14.14,1.35,0,0,2.77,5.42,8.85,3.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.12,22.89s1.92,1.22,3.56,3.49"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.18,31.26c5.43,1.78,9.27-.98,14.39,1.75,4.17,2.23,6.19,6.85,5.62,10.08"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.42,52.12c2.2-1.9,3.91-4.43,4.69-7.7"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.09,49.37s-2.91.15-3.15,3.93c-.41,6.17,11.58,7.25,17.85,2.15"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.58,56.72s-1.66-2.5.23-6.14c1.41-2.69,4.41-5.71,9.12-6.38,7.9-1.14,10.13,3.39,8.19,5.04-1.74,1.47-2.67-.57-4.62-1.35h0c-.71-.3-1.55-.42-2.63-.15-.91.23-1.83.71-2.63,1.36-1.14.93-2.08,2.23-2.51,3.62-2.54,8.18,9.66,13.84,23.91,6.78,3.1-1.53,5.38-3.97,6.91-5.85,2.54-2.37,6.7-7.82,6.57-12.98"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M39.44,25.95s4.26.86,6.68,6.05"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M24.63,52.74c-2.47-.41-4.7-2.46-5.19-5.21-.33-1.83.11-3.97,1.76-6.17,1.34-1.78,2.94-2.78,2.94-2.78,1.99-13.62,15.3-12.63,15.3-12.63,7.65-8.34,16.68-3.06,16.68-3.06,12.32-4.72,18.05,4.2,18.05,4.2,10.01-3.86,12.16,6.89,12.16,6.89,10.49,1.14,8.11,12.78,8.11,12.78,4.54,4.61.38,9.26.38,9.26-.84,14.45-17,11.4-17,11.4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.8,60.42c.93-.98,1.68-2.35,2.01-4.24,0,0,7.28.17,6.19-7.56"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.2,40.49s-9.83-.12-14.16,7.85"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.14,54.03s-2.31,6.81,4.93,8.27"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.42,31.26s-.49,1.78-.48,3.88c0,.94.11,1.94.41,2.87"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34.94,35.14s-1.32,2.14-4.85,3.69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalaxyBrainReactionIcon);
export default __webpack_public_path__ + "static/media/galaxy-brain-reaction-icon.f6b7a1ada392debd31e41b39b4e31da1.svg";
export { ForwardRef as ReactComponent };